import React, { useState } from "react";
import { CategoryCardContainer } from "./style";
import { BiRightArrow } from "react-icons/bi";
import { Carousel } from "react-responsive-carousel";

import "react-responsive-carousel/lib/styles/carousel.min.css";

const CatergoryCard = ({ src, name, category, chooseCategory, active, sources }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <CategoryCardContainer src={``} active={active} onMouseOver={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <Carousel
                showThumbs={false}
                showIndicators={false}
                showStatus={false}
                autoPlay={isHovered}
                infiniteLoop
                interval={1000}
            >
                {sources.map((image) => (
                    <div key={image.id} className="carousel-container">
                        <img className="carousel-image" src={image.src} alt={name} />
                    </div>
                ))}
            </Carousel>
            <button className="choose-button" onClick={() => chooseCategory("category", category.id)}>
                <span>{name}</span>
                <BiRightArrow />
            </button>
        </CategoryCardContainer>
    );
};

export default CatergoryCard;
